import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from './cn'

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: ReactNode
  title?: ReactNode
  action?: ReactNode
  children?: ReactNode
}


const emptyStateRootClass = 'vjal-empty-state text-center px-5 py-12 text-ink-muted'
/** Empty / no-results state for lists, tables and modules. */
export function EmptyState({ icon, title, action, className = '', children, ...props }: EmptyStateProps) {
  return (
    <div data-empty-state className={cn(emptyStateRootClass, className)} {...props}>
      {icon && <div className="mx-auto mb-3 w-11 h-11 text-ink-muted">{icon}</div>}
      {title && <p className="font-display text-h4 text-strong m-0 mb-2">{title}</p>}
      {children && <p className="m-0 max-w-sm mx-auto">{children}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
